var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.622 118.544L136.626 121.669L143.619 128.663",
    stroke: "#F0C8B8",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 89.6448L74.3145 132.604",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 89.6448L58.6277 120.05",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 89.6448L103.543 126.086",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8575 89.6448L91.8125 48.2668",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 89.6449L67.2928 57.3144",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 89.6448L82.2476 123.414",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8064 101.289C49.9024 86.3407 57.2276 69.4561 72.166 63.5773",
    stroke: "black",
    strokeWidth: 1.04,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.905 79.0005C115.809 93.9488 108.484 110.833 93.5457 116.712",
    stroke: "black",
    strokeWidth: 1.04,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0324 109.47C73.9999 120.437 91.7667 120.452 102.716 109.503C113.665 98.5541 113.65 80.7873 102.682 69.8198C91.7148 58.8523 73.9479 58.8373 62.9989 69.7863C52.0499 80.7353 52.0649 98.5022 63.0324 109.47Z",
    stroke: "#F08456",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9846 108.517C74.4253 118.958 91.3388 118.972 101.762 108.549C112.185 98.1262 112.171 81.2127 101.73 70.7721C91.2893 60.3314 74.3759 60.3171 63.9528 70.7402C53.5297 81.1633 53.544 98.0767 63.9846 108.517Z",
    fill: "url(#paint0_radial_46_332)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6476 104.855C76.0619 113.269 89.6927 113.28 98.0928 104.88C106.493 96.4801 106.481 82.8493 98.0671 74.435C89.6528 66.0208 76.022 66.0093 67.6219 74.4094C59.2218 82.8095 59.2333 96.4402 67.6476 104.855Z",
    stroke: "#F0C8B8",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1128 77.3893C101.882 84.1581 101.891 95.1635 95.1335 101.921C88.3761 108.678 77.3706 108.669 70.6018 101.9C63.833 95.1314 63.8237 84.126 70.5811 77.3686C77.3385 70.6112 88.344 70.6204 95.1128 77.3893ZM95.2235 77.2786C88.3822 70.4373 77.3 70.4279 70.4702 77.2577C63.6404 84.0874 63.6498 95.1697 70.4911 102.011C77.3324 108.852 88.4146 108.862 95.2444 102.032C102.074 95.2021 102.065 84.1199 95.2235 77.2786Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5085 76.9936C102.496 83.9813 102.506 95.3413 95.5299 102.317C88.554 109.293 77.1939 109.284 70.2062 102.296C63.2185 95.3082 63.2089 83.9481 70.1849 76.9722C77.1608 69.9963 88.5208 70.0059 95.5085 76.9936ZM95.6222 76.8799C88.5606 69.8182 77.1193 69.8071 70.068 76.8583C63.0168 83.9096 63.0264 95.3494 70.0896 102.413C77.1527 109.476 88.5926 109.485 95.6438 102.434C102.695 95.3829 102.685 83.943 95.6222 76.8799Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0203 78.4818C100.186 84.6473 100.194 94.6716 94.0391 100.827C87.884 106.982 77.8598 106.973 71.6943 100.808C65.5289 94.6423 65.5204 84.618 71.6755 78.463C77.8305 72.3079 87.8548 72.3164 94.0203 78.4818ZM94.1207 78.3814C87.8886 72.1494 77.7935 72.1409 71.572 78.3624C65.3505 84.5839 65.359 94.6791 71.591 100.911C77.823 107.143 87.9182 107.152 94.1397 100.93C100.361 94.7086 100.353 84.6134 94.1207 78.3814Z",
    fill: "#999999"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9802 108.522C74.4234 118.965 91.3408 118.979 101.766 108.554C112.192 98.1282 112.178 81.2108 101.734 70.7677C91.2913 60.3246 74.3739 60.3103 63.9483 70.7358C53.5228 81.1614 53.5371 98.0788 63.9802 108.522Z",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.962 69.5015L131.949 69.4972L119.434 82.0126L110.911 82.0054",
    stroke: "#0B0D3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.275 110.405L128.742 110.425L142.435 124.118L161.349 124.134L176.257 109.225",
    stroke: "#F0C8B8",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.391 95.3503L123.141 95.3602L126.346 92.155L146.861 92.1723L153.033 86.001",
    stroke: "#0B0D3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.541 98.6107L137.208 98.6347L142.376 103.803L164.597 103.822L167.725 100.694",
    stroke: "#F0C8B8",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.238 85.7859L127.709 85.7964L139.792 73.7136L160.248 73.7309",
    stroke: "#0B0D3D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.757 73.4618L115.912 73.4704L121.28 68.1022",
    stroke: "#0B0D3D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9747 67.4281L107.648 67.4361L111.943 63.1413",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8131 88.9195L36.708 88.9051L22.0031 103.61",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9803 109.522L60.2701 113.232L39.2848 113.214L34.7343 108.664L25.3986 108.656",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9308 71.3934L56.4527 66.9154L36.8002 66.8988L31.105 61.2036",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8224 77.6314L42.247 77.6191L37.5373 82.3288L12.4855 82.3077",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8569 88.2901L19.9156 88.2614L18.296 89.881L5.88685 89.8706",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2793 99.8404L44.3684 99.8312L42.7148 101.485L26.752 101.473L23.309 104.916",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.163 127.465C103.373 127.675 103.713 127.675 103.922 127.466C104.132 127.256 104.132 126.916 103.922 126.706C103.712 126.497 103.372 126.496 103.162 126.706C102.953 126.915 102.953 127.255 103.163 127.465Z",
    fill: "white",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.567 124.734C82.3914 124.909 82.1047 124.909 81.9287 124.733C81.7527 124.557 81.7525 124.27 81.9282 124.095C82.1039 123.919 82.3905 123.919 82.5665 124.095C82.7425 124.271 82.7427 124.558 82.567 124.734Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5614 133.851C74.4241 133.988 74.2024 133.988 74.0664 133.852C73.9303 133.716 73.9286 133.493 74.0659 133.356C74.2032 133.218 74.4249 133.219 74.5624 133.356C74.7 133.494 74.6987 133.714 74.5614 133.851Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8702 121.293C58.7374 121.426 58.5216 121.425 58.3885 121.292C58.2554 121.159 58.2553 120.944 58.3881 120.811C58.521 120.678 58.7367 120.678 58.8698 120.811C59.0029 120.944 59.0031 121.16 58.8702 121.293Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9575 58.6495C67.1429 58.8349 67.4433 58.8351 67.6284 58.65C67.8135 58.4649 67.8132 58.1646 67.6278 57.9792C67.4424 57.7938 67.1421 57.7935 66.957 57.9786C66.7719 58.1637 66.7721 58.464 66.9575 58.6495Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M112.551 63.7492C112.215 64.0843 111.672 64.0838 111.336 63.7481C111 63.4124 111 62.8687 111.335 62.5335C111.67 62.1984 112.214 62.1988 112.55 62.5346C112.885 62.8703 112.886 63.414 112.551 63.7492Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1125 49.567C91.9471 49.7323 91.6782 49.7321 91.5126 49.5665C91.3469 49.4008 91.3467 49.1319 91.5121 48.9665C91.6774 48.8012 91.9463 48.8014 92.112 48.9671C92.2776 49.1327 92.2778 49.4016 92.1125 49.567Z",
    fill: "white",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M130.087 115.579L117.692 115.568L115.335 113.211L127.729 113.221L130.087 115.579ZM131.096 115.998L127.902 112.803L114.325 112.792L117.52 115.986L131.096 115.998Z",
    fill: "#0B0D3D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.78 120.87L141.525 120.863L143.232 122.57L150.487 122.576L148.78 120.87Z",
    fill: "#0B0D3D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8528 80.2477L21.5859 80.2349L23.2897 78.5311L38.5566 78.544L36.8528 80.2477Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3614 101.704L48.7777 101.707L47.0739 103.411L43.6562 103.409L45.3614 101.704Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1207 104.945L45.5384 104.946L43.8347 106.65L40.4169 106.649L42.1207 104.945Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8801 108.186L42.2978 108.187L40.5941 109.891L37.1763 109.889L38.8801 108.186Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.092 98.5586L140.531 98.5533L141.605 99.627L146.165 99.6308L145.092 98.5586Z",
    fill: "#0B0D3D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5645 89.6538C93.5595 83.7403 88.762 78.9428 82.8485 78.9378L82.8666 100.352C88.7801 100.357 93.5695 95.5672 93.5645 89.6538Z",
    fill: "url(#paint1_radial_46_332)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1506 89.6357C72.1555 95.5492 76.953 100.347 82.8665 100.352L82.8485 78.9378C76.935 78.9328 72.1456 83.7222 72.1506 89.6357Z",
    fill: "url(#paint2_radial_46_332)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8525 85.5088C80.5681 85.5069 78.7182 87.3568 78.7201 89.6412L86.9919 89.6482C86.99 87.3638 85.1369 85.5108 82.8525 85.5088Z",
    fill: "#0B0D3D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8595 93.7806C85.1439 93.7826 86.9939 91.9327 86.9919 89.6482L78.7201 89.6413C78.7221 91.9257 80.5751 93.7787 82.8595 93.7806Z",
    fill: "#F0C8B8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M160.901 115.365L141.08 115.349C140.477 115.348 139.982 114.853 139.98 114.248C139.979 113.645 140.474 113.151 141.078 113.15L160.899 113.167C161.502 113.167 161.998 113.663 161.999 114.267C162 114.87 161.505 115.364 160.901 115.365Z",
    fill: "#C1D8EB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8204 71.1847L18.0024 71.168C17.3995 71.1675 16.9041 70.6721 16.9021 70.0677C16.9016 69.4649 17.3962 68.9703 18.0005 68.9693L37.8215 68.986C38.4244 68.9865 38.9198 69.482 38.9218 70.0863C38.9223 70.6892 38.4277 71.1838 37.8234 71.1848L37.8204 71.1847Z",
    fill: "#E1E4E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M112.478 104.213L131.849 104.227",
    stroke: "#F0C8B8",
    strokeWidth: 11.39,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5239 63.7237L38.9623 63.7104L35.5046 60.2527",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9683 112.285L59.993 112.291",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7239 111.79L45.262 111.795",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2287 64.0189C56.392 64.1823 56.6566 64.1825 56.8197 64.0194C56.9828 63.8564 56.9826 63.5917 56.8192 63.4284C56.6559 63.265 56.3912 63.2648 56.2282 63.4279C56.0651 63.591 56.0653 63.8556 56.2287 64.0189Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M51.614 64.0461C51.4339 64.2262 51.1413 64.226 50.9609 64.0456C50.7805 63.8651 50.7802 63.5726 50.9603 63.3925C51.1405 63.2123 51.433 63.2126 51.6135 63.393C51.7939 63.5734 51.7941 63.866 51.614 64.0461Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3467 63.9885C39.1637 64.1716 38.8652 64.1713 38.6818 63.9879C38.4984 63.8046 38.4982 63.5061 38.6812 63.323C38.8643 63.1399 39.1628 63.1402 39.3462 63.3236C39.5296 63.507 39.5298 63.8054 39.3467 63.9885Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8624 67.325C56.6365 67.5509 56.2715 67.5491 56.0467 67.3243C55.8219 67.0995 55.8216 66.7331 56.046 66.5087C56.2704 66.2842 56.6369 66.2846 56.8617 66.5093C57.0865 66.7341 57.0868 67.1006 56.8624 67.325Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7985 78.1708C42.4944 78.4749 42.0023 78.473 41.6991 78.1699C41.396 77.8667 41.3956 77.3732 41.6982 77.0705C42.0009 76.7678 42.4944 76.7683 42.7976 77.0714C43.1008 77.3746 43.1012 77.8681 42.7985 78.1708Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0722 82.7939C37.3295 83.0512 37.7463 83.0515 38.0031 82.7947C38.26 82.5378 38.2596 82.121 38.0023 81.8638C37.7451 81.6065 37.3283 81.6061 37.0714 81.863C36.8146 82.1198 36.8149 82.5366 37.0722 82.7939Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2247 88.5705C20.0549 88.7403 19.7771 88.7401 19.6071 88.57C19.437 88.3999 19.4367 88.1221 19.6065 87.9524C19.7763 87.7826 20.0541 87.7828 20.2242 87.9529C20.3943 88.1229 20.3945 88.4007 20.2247 88.5705Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5474 90.1324C18.4086 90.2712 18.1825 90.2725 18.042 90.132C17.9015 89.9915 17.9014 89.7669 18.0416 89.6266C18.1819 89.4864 18.4065 89.4866 18.547 89.6271C18.6874 89.7676 18.6876 89.9922 18.5474 90.1324Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7971 95.4165C30.6317 95.5818 30.3628 95.5816 30.1971 95.4159C30.0315 95.2503 30.0313 94.9814 30.1966 94.816C30.362 94.6507 30.6309 94.6509 30.7966 94.8165C30.9622 94.9822 30.9624 95.2511 30.7971 95.4165Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1041 100.096C44.2503 100.242 44.4871 100.242 44.6331 100.096C44.779 99.95 44.7788 99.7132 44.6326 99.567C44.4864 99.4208 44.2496 99.4206 44.1036 99.5665C43.9577 99.7125 43.9579 99.9493 44.1041 100.096Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1348 101.905C42.903 102.137 42.5277 102.136 42.2955 101.904C42.0633 101.672 42.063 101.297 42.2948 101.065C42.5266 100.833 42.9019 100.833 43.1341 101.065C43.3663 101.298 43.3666 101.673 43.1348 101.905Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2798 102.001C26.989 102.292 26.5161 102.291 26.2248 102C25.9335 101.709 25.9331 101.236 26.2239 100.945C26.5148 100.654 26.9876 100.654 27.2789 100.946C27.5703 101.237 27.5707 101.71 27.2798 102.001Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1351 109.065C34.9137 109.286 34.5531 109.286 34.3313 109.064C34.1094 108.842 34.1091 108.482 34.3306 108.26C34.5521 108.039 34.9126 108.039 35.1344 108.261C35.3563 108.483 35.3566 108.843 35.1351 109.065Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6678 88.4761C53.7723 88.5806 53.9417 88.5808 54.0461 88.4764C54.1504 88.372 54.1503 88.2027 54.0457 88.0981C53.9412 87.9936 53.7718 87.9934 53.6675 88.0978C53.5631 88.2022 53.5632 88.3715 53.6678 88.4761Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1772 77.9864C56.9823 78.1813 56.6661 78.181 56.4709 77.9858C56.2756 77.7906 56.2754 77.4744 56.4703 77.2795C56.6651 77.0846 56.9814 77.0849 57.1766 77.2801C57.3718 77.4753 57.3721 77.7915 57.1772 77.9864Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.231 71.6936C61.0893 71.8353 60.8602 71.8337 60.7197 71.6932C60.5793 71.5527 60.5791 71.3222 60.7193 71.1819C60.8596 71.0416 61.0901 71.0418 61.2306 71.1823C61.3711 71.3228 61.3713 71.5533 61.231 71.6936Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 66.8616C71.3975 67.0343 71.1168 67.0341 70.9438 66.8611C70.7707 66.688 70.7705 66.4073 70.9432 66.2346C71.116 66.0618 71.3967 66.0621 71.5697 66.2351C71.7428 66.4081 71.743 66.6889 71.5703 66.8616Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0815 67.8214C69.2187 67.9586 69.441 67.9588 69.578 67.8219C69.715 67.6849 69.7148 67.4626 69.5776 67.3254C69.4403 67.1881 69.218 67.188 69.0811 67.3249C68.9441 67.4619 68.9443 67.6842 69.0815 67.8214Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5199 65.9412C73.3782 66.0829 73.1507 66.0827 73.0087 65.9407C72.8667 65.7988 72.8665 65.5712 73.0083 65.4295C73.15 65.2878 73.3775 65.2879 73.5195 65.4299C73.6615 65.5719 73.6602 65.8009 73.5199 65.9412Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7578 63.7439C88.6323 63.8694 88.4284 63.8692 88.3027 63.7435C88.177 63.6178 88.1768 63.4139 88.3023 63.2884C88.4278 63.1629 88.6317 63.1631 88.7574 63.2888C88.8831 63.4145 88.8833 63.6184 88.7578 63.7439Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5157 56.1828C90.3267 56.3718 90.0208 56.3701 89.833 56.1823C89.6452 55.9944 89.6449 55.6871 89.8324 55.4996C90.0199 55.3121 90.3273 55.3123 90.5151 55.5002C90.7029 55.688 90.7032 55.9953 90.5157 56.1828Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M111.244 82.2998C111.081 82.4622 110.817 82.4634 110.653 82.2993C110.489 82.1351 110.488 81.8721 110.652 81.7082C110.816 81.5443 111.079 81.5446 111.243 81.7087C111.407 81.8729 111.408 82.1359 111.244 82.2998Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M111.678 95.6165C111.53 95.7642 111.292 95.7625 111.146 95.6161C110.999 95.4697 110.999 95.2303 111.145 95.0841C111.292 94.938 111.531 94.9382 111.677 95.0846C111.824 95.231 111.824 95.4704 111.678 95.6165Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M110.785 98.8548C110.651 98.9891 110.433 98.9875 110.3 98.8544C110.167 98.7213 110.167 98.5026 110.3 98.3697C110.433 98.2368 110.652 98.237 110.785 98.3701C110.918 98.5032 110.918 98.7219 110.785 98.8548Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M103.547 110.677C103.397 110.828 103.153 110.826 103.003 110.677C102.854 110.527 102.854 110.282 103.003 110.133C103.152 109.984 103.397 109.984 103.547 110.133C103.696 110.283 103.696 110.528 103.547 110.677Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5016 115.235C97.351 115.386 97.1057 115.385 96.9549 115.235C96.804 115.084 96.8038 114.838 96.9544 114.688C97.105 114.537 97.3503 114.537 97.5011 114.688C97.652 114.839 97.6522 115.084 97.5016 115.235Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4079 113.229C96.216 113.421 95.9057 113.421 95.7134 113.228C95.5212 113.036 95.5209 112.726 95.7129 112.534C95.9048 112.342 96.2151 112.342 96.4074 112.534C96.5996 112.727 96.5999 113.037 96.4079 113.229Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7206 116.694C82.5316 116.883 82.2258 116.881 82.0379 116.694C81.8501 116.506 81.8499 116.198 82.0374 116.011C82.2249 115.823 82.5322 115.824 82.72 116.012C82.9079 116.199 82.9081 116.507 82.7206 116.694Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8661 116.056C77.7465 116.176 77.5544 116.176 77.4346 116.056C77.3148 115.936 77.3146 115.744 77.4342 115.624C77.5538 115.505 77.7459 115.505 77.8657 115.625C77.9855 115.744 77.9857 115.937 77.8661 116.056Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0538 111.681C66.1445 111.772 66.2913 111.772 66.3818 111.681C66.4723 111.591 66.4722 111.444 66.3816 111.353C66.2909 111.263 66.144 111.262 66.0535 111.353C65.963 111.443 65.9631 111.59 66.0538 111.681Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3712 126.771C75.5795 126.979 75.9169 126.98 76.1248 126.772C76.3327 126.564 76.3325 126.226 76.1242 126.018C75.9159 125.81 75.5785 125.809 75.3706 126.017C75.1627 126.225 75.163 126.563 75.3712 126.771Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M101.274 121.889C101.127 122.035 100.89 122.036 100.742 121.888C100.594 121.741 100.594 121.504 100.741 121.357C100.889 121.209 101.125 121.209 101.273 121.357C101.421 121.505 101.421 121.741 101.274 121.889Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.213 101.696C55.9886 101.92 55.6251 101.92 55.4003 101.695C55.1756 101.47 55.1752 101.107 55.3997 100.882C55.6241 100.658 55.9876 100.658 56.2124 100.883C56.4371 101.108 56.4375 101.471 56.213 101.696Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9811 100.139C55.1461 100.304 55.4133 100.304 55.578 100.139C55.7428 99.9744 55.7425 99.7072 55.5775 99.5422C55.4126 99.3772 55.1453 99.377 54.9806 99.5417C54.8159 99.7064 54.8161 99.9737 54.9811 100.139Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M128.896 110.579C128.812 110.663 128.673 110.663 128.588 110.579C128.504 110.494 128.504 110.355 128.588 110.271C128.672 110.187 128.811 110.187 128.895 110.271C128.98 110.356 128.98 110.495 128.896 110.579Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M158.902 113.62C158.652 113.869 158.247 113.869 157.997 113.619C157.748 113.369 157.747 112.964 157.997 112.715C158.246 112.465 158.651 112.466 158.901 112.716C159.151 112.966 159.151 113.37 158.902 113.62Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M143.014 115.618C142.868 115.764 142.629 115.764 142.482 115.617C142.336 115.471 142.336 115.231 142.482 115.085C142.628 114.939 142.868 114.939 143.014 115.086C143.16 115.232 143.161 115.471 143.014 115.618Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M137.542 98.8714C137.369 99.0442 137.087 99.0454 136.913 98.8709C136.738 98.6964 136.738 98.4157 136.912 98.2414C137.086 98.0672 137.367 98.0675 137.541 98.242C137.716 98.4165 137.716 98.6972 137.542 98.8714Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M142.674 104.101C142.51 104.265 142.244 104.264 142.08 104.1C141.916 103.936 141.915 103.67 142.079 103.506C142.243 103.342 142.509 103.342 142.673 103.507C142.838 103.671 142.838 103.937 142.674 104.101Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M125.922 92.5787C126.157 92.8131 126.537 92.8134 126.771 92.5794C127.005 92.3454 127.004 91.9656 126.77 91.7312C126.535 91.4968 126.156 91.4965 125.922 91.7305C125.688 91.9645 125.688 92.3443 125.922 92.5787Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M122.717 95.7839C122.952 96.0183 123.331 96.0187 123.565 95.7847C123.799 95.5506 123.799 95.1709 123.565 94.9365C123.33 94.7021 122.951 94.7018 122.717 94.9358C122.483 95.1698 122.483 95.5495 122.717 95.7839Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M119.897 82.4755C120.153 82.2201 120.152 81.8064 119.896 81.5505C119.641 81.2947 119.227 81.2943 118.971 81.5497C118.716 81.8051 118.716 82.2189 118.972 82.4747C119.228 82.7306 119.642 82.7309 119.897 82.4755Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M131.656 69.7911C131.818 69.9537 132.082 69.9539 132.244 69.7916C132.406 69.6294 132.406 69.3661 132.243 69.2035C132.081 69.041 131.817 69.0408 131.655 69.203C131.493 69.3653 131.493 69.6286 131.656 69.7911Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M107.879 67.6668C108.006 67.5399 108.007 67.3315 107.878 67.2029C107.75 67.0742 107.543 67.074 107.414 67.2025C107.286 67.3309 107.286 67.5378 107.415 67.6664C107.543 67.7951 107.75 67.7953 107.879 67.6668Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 67.7818C121.767 67.9485 122.037 67.9487 122.203 67.7823C122.369 67.616 122.369 67.3461 122.202 67.1795C122.036 67.0129 121.766 67.0126 121.6 67.179C121.433 67.3453 121.433 67.6152 121.6 67.7818Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M136.003 108.686L150.168 108.698",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M135.646 109.043C135.844 109.241 136.164 109.241 136.361 109.044C136.559 108.847 136.558 108.526 136.361 108.329C136.163 108.131 135.843 108.131 135.645 108.328C135.448 108.525 135.448 108.846 135.646 109.043Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.884 108.981C150.041 109.138 150.295 109.138 150.452 108.982C150.608 108.825 150.608 108.571 150.451 108.415C150.295 108.258 150.041 108.257 149.884 108.414C149.727 108.571 149.728 108.825 149.884 108.981Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8514 85.5771L47.0145 85.5876",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2093 85.935C33.4072 85.7372 33.4069 85.418 33.2087 85.2199C33.0105 85.0217 32.6914 85.0214 32.4935 85.2193C32.2957 85.4171 32.296 85.7363 32.4941 85.9344C32.6923 86.1326 33.0115 86.1329 33.2093 85.935Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7312 85.8711C46.888 86.0279 47.142 86.0281 47.2986 85.8716C47.4551 85.715 47.4549 85.461 47.2981 85.3042C47.1413 85.1474 46.8872 85.1471 46.7307 85.3037C46.5741 85.4603 46.5743 85.7143 46.7312 85.8711Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32107 94.1238L22.4857 94.1357",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67893 94.4817C8.87677 94.2838 8.87649 93.9647 8.67832 93.7665C8.48015 93.5683 8.16099 93.5681 7.96315 93.7659C7.76532 93.9637 7.76559 94.2829 7.96376 94.4811C8.16193 94.6792 8.48109 94.6795 8.67893 94.4817Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2022 94.4192C22.359 94.576 22.613 94.5763 22.7696 94.4197C22.9261 94.2632 22.9259 94.0091 22.7691 93.8523C22.6123 93.6955 22.3582 93.6953 22.2017 93.8518C22.0451 94.0084 22.0454 94.2624 22.2022 94.4192Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M34.719 109.833L34.7219 113.273",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3592 99.4589L44.3564 94.4423L43.0624 93.1483",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6516 93.1479C42.7651 93.2615 42.949 93.2616 43.0624 93.1483C43.1757 93.0349 43.1755 92.851 43.062 92.7375C42.9485 92.624 42.7646 92.6238 42.6512 92.7372C42.5379 92.8505 42.538 93.0344 42.6516 93.1479Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1883 92.2743C42.0747 92.388 41.8914 92.3878 41.7776 92.2739C41.6637 92.1601 41.6635 91.9768 41.7772 91.8632C41.8909 91.7495 42.0741 91.7496 42.188 91.8635C42.3019 91.9774 42.302 92.1606 42.1883 92.2743Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M42.297 101.903L38.8541 105.346",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3727 105.827C38.514 105.968 38.7429 105.968 38.884 105.827C39.025 105.686 39.0248 105.457 38.8835 105.316C38.7422 105.175 38.5133 105.175 38.3723 105.316C38.2312 105.457 38.2314 105.686 38.3727 105.827Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7981 77.623L46.7948 73.6895L43.9553 70.8501",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3452 78.1702C47.044 78.4714 46.5535 78.4709 46.2518 78.1693C45.9501 77.8676 45.9497 77.377 46.2509 77.0758C46.552 76.7746 47.0426 76.775 47.3443 77.0767C47.646 77.3784 47.6464 77.869 47.3452 78.1702Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9553 70.8501C43.8239 70.9815 43.6111 70.9813 43.4795 70.8497C43.3479 70.718 43.3477 70.5053 43.4791 70.3739C43.6105 70.2425 43.8233 70.2426 43.9549 70.3743C44.0865 70.5059 44.0867 70.7187 43.9553 70.8501Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0595 73.9542C46.9133 74.1004 46.6769 74.1002 46.5305 73.9538C46.3841 73.8074 46.3839 73.571 46.53 73.4248C46.6762 73.2786 46.9126 73.2788 47.059 73.4252C47.2054 73.5716 47.2056 73.8081 47.0595 73.9542Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M146.862 92.1723L151.675 96.986L164.662 96.9985",
    stroke: "#F0C8B8",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M135.42 79.2304L138.633 82.444L150.747 82.4542",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.833 80.2193L133.289 77.6756C133.131 77.5174 133.131 77.2573 133.289 77.0993C133.447 76.9414 133.707 76.9416 133.865 77.0998L136.409 79.6435C136.567 79.8017 136.567 80.0618 136.409 80.2198C136.251 80.3777 135.991 80.3775 135.833 80.2193Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M123.048 76.739L128.164 76.7433",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M124.752 73.4646L124.76 81.893",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M125.073 77.0747C124.881 77.2666 124.568 77.2664 124.376 77.0741C124.183 76.8819 124.183 76.5686 124.375 76.3767C124.567 76.1847 124.88 76.185 125.073 76.3773C125.265 76.5695 125.265 76.8828 125.073 77.0747Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M124.979 82.3719C124.865 82.4856 124.679 82.4854 124.565 82.3716C124.451 82.2577 124.451 82.0715 124.565 81.9578C124.678 81.8442 124.864 81.8443 124.978 81.9582C125.092 82.0721 125.092 82.2582 124.979 82.3719Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M124.525 73.3993C124.654 73.5284 124.863 73.5286 124.992 73.3997C125.12 73.2709 125.12 73.0618 124.991 72.9328C124.862 72.8038 124.653 72.8036 124.524 72.9324C124.395 73.0612 124.396 73.2703 124.525 73.3993Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M129.063 77.1401C129.271 76.932 129.271 76.5921 129.062 76.3836C128.854 76.1751 128.514 76.1748 128.306 76.3829C128.097 76.5911 128.098 76.931 128.306 77.1395C128.515 77.348 128.855 77.3483 129.063 77.1401Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M122.97 77.0478C123.118 76.9001 123.119 76.6593 122.97 76.5099C122.82 76.3605 122.581 76.3603 122.432 76.5095C122.283 76.6586 122.283 76.8979 122.432 77.0473C122.582 77.1967 122.821 77.1969 122.97 77.0478Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M110.074 78.9357C109.92 79.0892 109.669 79.089 109.515 78.9352C109.361 78.7814 109.361 78.5302 109.515 78.3767C109.668 78.2231 109.919 78.2233 110.073 78.3771C110.227 78.5309 110.227 78.7821 110.074 78.9357Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M137.144 118.826C136.857 119.113 136.39 119.113 136.103 118.826C135.816 118.539 135.816 118.072 136.102 117.785C136.389 117.499 136.856 117.499 137.143 117.786C137.43 118.073 137.43 118.54 137.144 118.826Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M143.128 86.6073L134.579 86.6016",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M142.77 86.2494C142.572 86.4473 142.572 86.7664 142.77 86.9646C142.968 87.1628 143.288 87.163 143.485 86.9652C143.683 86.7674 143.683 86.4482 143.485 86.25C143.287 86.0519 142.968 86.0516 142.77 86.2494Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M134.294 86.3162C134.138 86.4727 134.138 86.7268 134.295 86.8836C134.451 87.0403 134.705 87.0405 134.862 86.884C135.018 86.7276 135.018 86.4734 134.861 86.3166C134.705 86.1599 134.451 86.1597 134.294 86.3162Z",
    fill: "#0B0D3D",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M143.485 86.2501L144.226 85.5089L146.702 85.511",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M143.485 86.9652L144.272 87.752L151.294 87.7579",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M147.511 85.8885C147.317 86.0819 147.004 86.0816 146.81 85.8879C146.617 85.6941 146.616 85.3809 146.81 85.1875C147.003 84.9941 147.317 84.9943 147.51 85.1881C147.704 85.3818 147.704 85.6951 147.511 85.8885Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M151.533 88.0832C151.377 88.2397 151.124 88.238 150.969 88.0827C150.814 87.9274 150.813 87.6733 150.968 87.5182C151.124 87.3632 151.378 87.3634 151.533 87.5187C151.688 87.674 151.688 87.9281 151.533 88.0832Z",
    fill: "#C1D8EB",
    stroke: "#0B0D3D",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_46_332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.8573 89.6447) rotate(45) scale(26.735 26.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EDF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E4E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_46_332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.8543 89.6461) rotate(89.9517) scale(10.7076 10.7076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F6F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D9DDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C3C9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A9B1B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E999E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_46_332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.8543 89.6461) rotate(89.9517) scale(10.7076 10.7076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EAEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLogo);
export default __webpack_public_path__ + "static/media/title-logo.e876397def4ccf42dffbfbfd2433e0a8.svg";
export { ForwardRef as ReactComponent };